import { useState, useEffect } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../CustomSelect";
import resetImg from "../../../../../picture/timer-language.png";

const istekDokumentaAll = [
  { id: "sve", name: "SVI DOKUMENTI" },
  { id: "1", name: "ISTEKLI DOKUMENTI" },
  { id: "2", name: "ISTIČU USKORO (ALARM)" },
  { id: "3", name: "VAŽEĆI DOKUMENTI" },
];

const defaultPretraga = {
  vrsta: { id: "sve", name: "SVE" },
  istekDokumenta: { id: "sve", name: "SVI DOKUMENTI" },
  poslovnaJedinica: { id: "sve", name: "SVE" },
  pretraga: "",
};

function PretragaSredstva({ onClose }) {
  const {
    sredstvaOpremaPretraga,
    setSredstvaOpremaPretraga,
    dictionary,
    baseUrl,
    selectedMainEntity,
  } = useGlobalContext();

  const [pretraga, setPretraga] = useState(sredstvaOpremaPretraga || defaultPretraga);
  const [vrsteIzBaze, setVrsteIzBaze] = useState([]);
  const [poslovneIzBaze, setPoslovneIzBaze] = useState([]);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    setPretraga(sredstvaOpremaPretraga || defaultPretraga);
    setIsDirty(false);
  }, [sredstvaOpremaPretraga]);

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    const fetchFilters = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/machines/get_search_filters.php`,
          { company_id: selectedMainEntity.company_id }
        );
        setVrsteIzBaze(data.vrste || []);
        setPoslovneIzBaze(data.poslovne || []);
      } catch (err) {
        console.error("Greška pri učitavanju filtera:", err);
      }
    };
    fetchFilters();
  }, [baseUrl, selectedMainEntity]);

  const onSelectChangeVrsta = (v) => { setPretraga((p) => ({ ...p, vrsta: v })); setIsDirty(true); };
  const onSelectChangeIstekDokumenta = (v) => { setPretraga((p) => ({ ...p, istekDokumenta: v })); setIsDirty(true); };
  const onSelectChangePoslovnaJedinica = (v) => { setPretraga((p) => ({ ...p, poslovnaJedinica: v })); setIsDirty(true); };
  const onChangePretraga = (e) => { setPretraga((p) => ({ ...p, pretraga: e.target.value })); setIsDirty(true); };

  const handlePretraga = () => { setSredstvaOpremaPretraga(pretraga); setIsDirty(false); };
  const handleReset = () => { setPretraga(defaultPretraga); setSredstvaOpremaPretraga(null); setIsDirty(false); };

  return (
    <div style={{ padding: "10px" }}>
      <CustomSelect label={dictionary["vrstaSiO"]} allValues={vrsteIzBaze} selectedValue={pretraga.vrsta} onSelectChange={onSelectChangeVrsta} />
      <div style={{ margin: "5px 0" }}></div>
      <CustomSelect label={dictionary["poslovnaJedinica"]} allValues={poslovneIzBaze} selectedValue={pretraga.poslovnaJedinica} onSelectChange={onSelectChangePoslovnaJedinica} />
      <div style={{ margin: "5px 0" }}></div>
      <CustomSelect label={dictionary["istekDokumenta"]} allValues={istekDokumentaAll} selectedValue={pretraga.istekDokumenta} onSelectChange={onSelectChangeIstekDokumenta} />
      <div style={{ margin: "5px 0" }}></div>
      <input
        value={pretraga.pretraga}
        onChange={onChangePretraga}
        placeholder={`${dictionary["pretraga"]}...`}
        style={{ width: "100%", fontSize: "16px", height: "40px", padding: "10px" }}
      />
      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <div onClick={() => { if (isDirty) handlePretraga(); else onClose?.(); }} style={{ flex: 8 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            {isDirty ? dictionary["pretrazi"] : dictionary["zatvori"] || "ZATVORI"}
          </Button>
        </div>
        <div onClick={handleReset} style={{ flex: 2 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            <img src={resetImg} alt="Reset" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PretragaSredstva;